export const manipulateAccessUsers = (type, payload) => {
    return {
    type: type,
    payload: payload
}};